import axios from "axios";
import { env } from "@shared/config";
import { checkToken } from "@shared/lib/session-service";

const backendUrl = import.meta.env.VITE_API_BASE_URL;
const command = import.meta.env.VITE_COMMAND;

const createApi = (baseURL: string) => {
  const api = axios.create({
    baseURL: `${backendUrl}${baseURL}`,
  });

  api.interceptors.request.use((config) => checkToken(config, { useOldToken: false }));

  return api;
};

const createLegacyApi = (
  baseURL: string,
  settings = { useOldToken: false },
) => {
  const prefix = command === "serve" ? "" : env.API_OLD_BASE_URL;
  const url = settings.useOldToken ? baseURL : `${prefix}${baseURL}`;

  const api = axios.create({
    baseURL: url,
  });

  api.interceptors.request.use((config) => checkToken(config, settings));

  return api;
};

export const s3AdapterApi = createApi("/s3-adapter/api/v1");
export const userServiceApi = createApi("/user-service");
export const oldBaseApi =
  command === "serve"
    ? createLegacyApi("/old-builddocs-api", { useOldToken: true })
    : createLegacyApi(`${env.API_OLD_BASE_URL}`, { useOldToken: true });
